import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ViewUIPlus from 'view-ui-plus'
import store from './store'
import dayjs from 'dayjs'
import 'view-ui-plus/dist/styles/viewuiplus.css'
// 2025-04-03
// 解决[Violation] Added non-passive event listener to a scroll-blocking ‘mousewheel’ event. Consider marking event handler as ‘passive’ to make the page more responsive.
// 安装 yarn add default-passive-events
// 引用 default-passive-events
import 'default-passive-events'

// 创建应用实例
const app = createApp(App)
// 初始化VueRouter
app.use(router);
// 挂载View-ui-plus
app.use(ViewUIPlus)
// 状态管理
app.use(store)
// 时间处理函数
app.config.globalProperties.$dayjs = dayjs;
// Vue 会显示很多警告信息, 禁用它们
app.config.productionTip = false;
app.config.devtools = false;
// 配置全局错误处理
// 保存原始的 console.warn
// const originalWarn = console.warn;
// 劫持 console.warn 自定义输出控制台
// console.warn = function (message, ...args) {
//     if (message.includes('Unexpected error when starting the router')) {
//         // console.error('捕获到 Vue Router 警告:', message, ...args);
//         // 你可以在这里将错误信息发送到服务器
//     } else {
//         // 调用原始的 console.warn
//         originalWarn.apply(console, [message, ...args]);
//     }
// };
// app.config.errorHandler = function (err, vm, info) {
//     // 在这里处理错误
//     console.error('全局错误捕获:', err);
//     console.error('错误所在的 Vue 实例:', vm);
//     console.error('错误信息:', info);
//     // 如果你想阻止错误继续向上冒泡（避免控制台显示默认错误），可以返回 false
//     return true;
// };
// // 捕获全局的 JavaScript 错误，并阻止它们显示在控制台中
// window.onerror = function (message, source, lineno, colno, error) {
//     // 在这里处理错误
//     console.error('全局错误捕获:');
//     console.error('错误信息:', message);
//     console.error('错误文件:', source);
//     console.error('错误行号:', lineno);
//     console.error('错误列号:', colno);
//     console.error('错误对象:', error);
//     // 返回 true 可以阻止默认的错误提示
//     return true;
// };
// // Vue Router 错误处理
// router.onError((err) => {
//     console.error('Vue Router 错误捕获:', err);
//     return
// });
// 挂载应用
app.mount('#app')